<template>
  <tabbar-item class="ym-tabbbar-column-item"
               :class="[
                 `type-${type}`,
                 { 'is-disabled': disabled },
                 { 'is-round': round },
               ]"
               :disabled="disabled"
               @click="handleClick"
  >
    <slot />
  </tabbar-item>
</template>

<script>
  import TabbarItem from '@/components/YmTabbarItem';

  export default {
    name: 'YmTabbarColumnItem',
    components: {
      TabbarItem,
    },
    props: {
      type: {
        type: String,
        default: 'normal',
        validator(val) {
          return [
            'normal',
            'primary',
            'gradient-primary',
            'secondary',
            'black-gold',
            'gold-black',
            'gradient-training',
          ].includes(val);
        },
      },
      round: Boolean,
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    methods: {
      handleClick() {
        this.$emit('click');
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .ym-tabbbar-column-item {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    &.type-normal {
      background: @color-white;
    }

    &.type-secondary {
      background-color: @tabbar-background-secondary;
      color: @tabbar-color-secondary;
    }

    &.type-primary {
      background-color: @color-primary;
      color: @color-white;
    }

    &.type-gradient-primary {
      background: @gradient-primary;
      color: @color-white;
    }

    &.type-gradient-training {
      background: @training-gradient;
      color: @color-white;
    }

    &.type-gold-black {
      background: @color-gold-dark;

      &.is-round {
        height: 80%;
        border-radius: @bottom-bar-height;
      }

      &.is-disabled {
        opacity: 1;
        color: fade(@color-text-base, 40%);

        /deep/ .ym-price {
          opacity: .4;
        }
      }
    }
    &.type-black-gold {
      background: @gradient-black;
      color: @color-text-gold;
    }

    &.is-disabled {
      pointer-events: none;
      opacity: .7;
    }
  }
</style>
